<template>
  <div>
    <div class="btn-planning">
      <el-button class="default"
                 @click="verify">
        ENVIAR PLANIFICACIÓN
      </el-button>
    </div>
    <DialogSummary ref="summary"
                   @sendPlanning="sendPlanning"/>
  </div>
</template>

<script>
import moment from 'moment';
import DialogSummary from './Summary.vue';
import { apiRequest } from '../../../backend/vue-axios/axios';

export default {
  props: {
  },
  name: 'PlanningSend',
  components: {
    DialogSummary,
  },
  data() {
    return {
      suborders: { socs: [] },
      generalData: {},
      msgGeneralData: {
        title: 'Datos generales',
        message: 'Complete los datos faltantes',
      },
      msgSuborders: {
        title: 'Subordenes',
        message: 'Ninguna soc planificable ingresada',
      },
    };
  },
  methods: {
    verify() {
      this.$emit('validation');
    },
    showSummary(data, validGeneralData) {
      const msg = [];
      if (validGeneralData) msg.push(this.msgGeneralData);
      if (this.suborders.socs.length < 1) msg.push(this.msgSuborders);
      if (msg.length === 0) {
        this.generalData = data;
        this.$refs.summary.show(data, this.suborders.counts);
      } else {
        this.notifyErrors(msg);
      }
    },
    notifyErrors(msg) {
      msg.forEach((m, i) => {
        setTimeout(() => { this.$notify.warning(m); }, i * 100);
      });
    },
    getSuborders(data) {
      this.suborders = data;
    },
    sendPlanning() {
      const today = moment(this.generalData.date, 'YYYY-MM-DD').toDate();
      const data = {
        travel_types_id: 999998,
        vehicle_list: [this.generalData.patent.id],
        enterprises_id: [this.generalData.enterprise.id],
        distribution_centers_id: [this.generalData.distributionCenter.id],
        time_init: moment(today.setHours(9, 0, 0, 0))
          .format('YYYY-MM-DDTHH:mm:SSZ'),
        time_finish: moment(today.setHours(21, 0, 0, 0))
          .format('YYYY-MM-DDTHH:mm:SSZ'),
        suborder_list: this.suborders.socs,
      };
      if (this.generalData.transferCenter !== '') {
        data.transfer_centers_id = this.generalData.transferCenter.id;
      }
      this.planning(data);
    },
    planning(params) {
      apiRequest({
        module: 'planning',
        service: 'planning_with_soc_list',
        params,
      }).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Listo',
          message: 'Se ha creado la planificación con éxito',
        });
        this.$emit('success', response.data.planning_tracker);
        this.$refs.summary.closeDialog();
      }).catch((error) => {
        this.$refs.summary.closeDialog();
        if (error.response) {
          let respuesta = '';
          if (error.response.status === 404) {
            respuesta = 'No se encontraron subordenes con los parametros dados';
          } else if (error.response.status === 400) {
            respuesta = 'Problemas con los parametros, revisalo e intentalo nuevamente';
          } else if (error.response.status === 500) {
            respuesta = 'Error inesperado, intentelo más tarde';
          }
          this.$notify({
            type: error.response.status !== 404 ? 'error' : 'warning',
            title: error.response.status !== 404 ? 'Error' : 'Problema',
            message: respuesta,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn-planning {
    text-align: right;
    margin: 30px 0 20px 0;
    .el-button { width: 250px; }
  }
</style>
